import type { RootState } from "../store"

export const organizationSelector = (state: RootState) => state.organization
